export function setNestedValue<T extends Record<string, any>>(parent: T, field: string, value: unknown) {
  const nestedFields = field.split('.');

  function clone(obj: any, index: number): any {
    const key = nestedFields[index];
    const isLast = index === nestedFields.length - 1;

    const currentValue = obj?.[key];
    const newValue = isLast
      ? value
      : clone(currentValue !== null && typeof currentValue === 'object' ? currentValue : {}, index + 1);

    const copy = Array.isArray(obj) ? [...obj] : { ...obj };

    copy[key] = newValue;

    return copy;
  }

  return clone(parent, 0);
}
